import React from "react"
import { Button } from "../../../ui/button"
import { cn } from "../../../lib/utils"

/**
 * VButtonGroup - Vertical button group for Accept/Decline actions
 * Migrated to use shadcn/ui Button component
 *
 * @param {function} accept - Accept button handler
 * @param {function} decline - Decline button handler
 * @param {Array} buttons - Button labels ["Accept", "Decline"]
 * @param {string} size - Button size passed to shadcn Button (default: "default")
 * @param {boolean} freezButton - Disable buttons
 */
export default function VButtonGroup(props) {
  const { accept, decline, buttons = [], size = "default", freezButton } = props

  return (
    <div className="grid justify-center gap-2">
      {buttons.includes("Accept") && (
        <Button
          onClick={accept}
          className={cn(
            buttons.length > 1 && "mb-2"
          )}
          id="DepositAcceptbtn"
          disabled={freezButton}
          variant="default"
          size={size}
        >
          {buttons[0] || "Accept"}
        </Button>
      )}

      {buttons.includes("Decline") && (
        <Button
          onClick={decline}
          id="DepositDeclinebtn"
          disabled={freezButton}
          variant="destructive"
          size={size}
        >
          {buttons[buttons.length - 1] || "Decline"}
        </Button>
      )}
    </div>
  )
}
